import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, RichText, MediaUpload, InspectorControls, InnerBlocks } from '@wordpress/block-editor';
import { PanelBody, Button } from '@wordpress/components';
import { Fragment, useEffect } from '@wordpress/element';
import { useDispatch, useSelect } from '@wordpress/data';
import './block-styles.css';

registerBlockType('custom-blocks/service-showcase-tab-content', {
    title: 'Service Showcase Tab Content',
    icon: 'admin-page',
    category: 'custom-blocks',
    parent: ['custom-blocks/service-showcase'],
    attributes: {
        tabTitle: {
            type: 'string',
            default: 'Tab Title',
        },
        icon: {
            type: 'string',
            default: 'https://via.placeholder.com/50',
        },
    },
    edit: ({ attributes, setAttributes, clientId }) => {
        const { tabTitle, icon } = attributes;
        const { updateBlockAttributes } = useDispatch('core/block-editor');

        // Identificar el bloque padre
        const parentBlockId = useSelect((select) => select('core/block-editor').getBlockParents(clientId)[0]);

        useEffect(() => {
            if (parentBlockId) {
                // Asegurar que el bloque padre esté identificado
                updateBlockAttributes(parentBlockId, {
                    tabDetails: {
                        [clientId]: { tabTitle, icon }
                    }
                });
            }
        }, [tabTitle, icon, parentBlockId]); // Añadir parentBlockId a las dependencias

        return (
            <Fragment>
                <InspectorControls>
                    <PanelBody title="Tab Content Settings">
                        <RichText
                            label="Tab Title"
                            value={tabTitle}
                            onChange={(value) => setAttributes({ tabTitle: value })}
                            placeholder="Enter tab title"
                        />
                        <MediaUpload
                            onSelect={(media) => setAttributes({ icon: media.url })}
                            allowedTypes={['image']}
                            render={({ open }) => (
                                <Button onClick={open}>
                                    {icon ? <img src={icon} alt="icon" width="50" /> : 'Select Icon'}
                                </Button>
                            )}
                        />
                    </PanelBody>
                </InspectorControls>
                <div {...useBlockProps()}>
                    <InnerBlocks templateLock={false} /> {/* Permitir bloques personalizados */}
                </div>
            </Fragment>
        );
    },
    save: ({ attributes }) => {
        const blockProps = useBlockProps.save(); // Obtener propiedades del bloque

        return (
            <div {...blockProps}>
                <InnerBlocks.Content /> {/* Renderizar bloques anidados correctamente */}
            </div>
        );
    },
});
